"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * If the path has changed but we're still in the app (the user has clicked
 * on a react router Link, probably), then scroll to the top.
 */
exports.useScrollToTop = function () {
    react_1.useEffect(function () {
        window.scrollTo(0, 0);
    }, []);
};
/**
 * Helper that provides a binding ref and a function that, when triggered,
 * will scroll the page to the element holding the ref.
 *
 * @example
 * const [bind, performScroll] = useScrollTo();
 * return (
 *  <div {...bind}>
 *    <p>This div will be scrolled to...</p>
 *  </div>
 *  [...]
 *  <button onClick={performScroll}>...when this button is clicked</button>
 * )
 *
 */
function useScrollTo() {
    var ref = react_1.useRef(null);
    var triggerScroll = react_1.useCallback(function (yOffset, behavior, scrollIfAlreadyVisible) {
        if (yOffset === void 0) { yOffset = 70; }
        if (behavior === void 0) { behavior = "smooth"; }
        if (scrollIfAlreadyVisible === void 0) { scrollIfAlreadyVisible = false; }
        if (ref.current !== null) {
            var _a = ref.current.getBoundingClientRect(), top_1 = _a.top, bottom = _a.bottom;
            if (!scrollIfAlreadyVisible && top_1 >= 0 && bottom <= window.innerHeight)
                return;
            var yCoord = top_1 + window.pageYOffset;
            window.scrollTo({
                top: yCoord + yOffset,
                behavior: behavior,
            });
        }
    }, []);
    return [{ ref: ref }, triggerScroll];
}
exports.useScrollTo = useScrollTo;
